<template>
  <div>
    <v-btn color="green" small dark @click="openModal">
      <v-icon left>mdi-plus</v-icon>
      Crea una nueva
    </v-btn>
    <v-dialog v-model="modal" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon class="error--text" @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text max-height="600px" class="pa-0">
          <establecimiento :modal.sync="modal" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Establecimiento from '../views/RU/Establecimiento.vue'
export default {
  name: 'ModalEstablecimiento',
  components: {
    Establecimiento,
  },
  data: () => {
    return {
      modal: false,
    }
  },
  methods: {
    openModal() {
      this.modal = true
    },
    cerrarModal() {
      this.modal = false
    },
  },
}
</script>
